// extracted by mini-css-extract-plugin
export default {"container":"Sizes_container__boxpg","orientationButton":"Sizes_orientationButton__x+lYw"};